import { Controller } from "@hotwired/stimulus"

// Comments icon: bounce + dot appear on click. 250ms.
export default class extends Controller {
  bounce() {
    this.element.classList.remove("icon-comments--bounce")
    void this.element.offsetWidth
    this.element.classList.add("icon-comments--bounce")
    setTimeout(() => this.element.classList.remove("icon-comments--bounce"), 250)
  }
}
